import { render } from "./ste_lineasdecompania.vue?vue&type=template&id=6bc21fcb&scoped=true"
import script from "./ste_lineasdecompania.vue?vue&type=script&lang=js"
export * from "./ste_lineasdecompania.vue?vue&type=script&lang=js"

import "./ste_lineasdecompania.vue?vue&type=style&index=0&id=6bc21fcb&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc21fcb"]])

export default __exports__